import { BaseComponent } from '../../base-component';
import { DimensionValueByType, DimensionsStateEvent, UNKNOWN_DIMENSION_TYPE_NAME, DimensionType } from '../shared-types';
import { decodeHtml } from '../../_common/client/decode-html';
import { DIMENSION_SELECTED_TOPIC } from '../../constants';
import { setupDimensionTiles } from './setup-dimension-tiles';
import { trackAvailableDimensionUiTypes as trackAvailableDimensionTypes, trackInvalidDimensions } from './tracking/tracking-helpers';
import { getCurrentDimensionsForDimensionStateEvent } from './get-current-dimensions-for-dimension-state-event';
import { updateDimensionSelectionPriorityInStorage } from './update-dimension-selection-priority-in-storage';
import { isEnabledDimensionInput } from './is-enabled-dimension-input';

export class DimensionSelectionComponent extends BaseComponent {
    public rootSelector = '.js_pdp_dimension-selection';
    private loadedDimensionsState: DimensionValueByType[] = [];
    private teardownDimensionTiles?: () => void;

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.teardownDimensionTiles?.();

        trackAvailableDimensionTypes(this.getRootElement());

        this.loadedDimensionsState = this.getDimensionsStateFromDataAttributes();

        trackInvalidDimensions(this.loadedDimensionsState);

        for (const dimensionBlock of this.getDimensionBlocks()) {
            let dimensionTilesAndDropDown = this.getDimensionTilesAndDropDown(dimensionBlock);
            dimensionTilesAndDropDown = this.resetAllDimensionTilesAndDropDown(dimensionTilesAndDropDown, dimensionBlock);

            const dimType = dimensionBlock.dataset.dimType || UNKNOWN_DIMENSION_TYPE_NAME;
            for (const dimensionButtonOrDropDown of dimensionTilesAndDropDown) {
                dimensionButtonOrDropDown.addEventListener('change', (event: Event) => {
                    const dimensionTypeUsed = (event.currentTarget as HTMLElement).closest<HTMLElement>('[data-dimension-type]')?.dataset
                        .dimensionType as DimensionType | undefined;

                    this.dimensionChangedEventListener(dimType, dimensionButtonOrDropDown, dimensionTypeUsed);
                });
            }
        }

        this.initTeamAssetsDropdowns();

        this.teardownDimensionTiles = setupDimensionTiles(this.getRootElement());
    }
    private resetAllDimensionTilesAndDropDown(
        dimensionButtonsAndDropDowns: (HTMLInputElement | HTMLSelectElement)[],
        dimensionBlock: HTMLElement
    ) {
        dimensionButtonsAndDropDowns.forEach(dimensionButtonOrDropDown => {
            dimensionButtonOrDropDown.replaceWith(dimensionButtonOrDropDown.cloneNode(true));
        });
        dimensionButtonsAndDropDowns = this.getDimensionTilesAndDropDown(dimensionBlock);
        return dimensionButtonsAndDropDowns;
    }

    private getDimensionTilesAndDropDown(dimensionBlock: HTMLElement) {
        const dimensionButtons = Array.from(dimensionBlock.querySelectorAll<HTMLInputElement>('input[type="radio"]'));
        const dimensionDropDowns = Array.from(
            dimensionBlock.querySelectorAll<HTMLSelectElement>('select.js_pdp_dimension-selection_dropdown')
        );

        return [...dimensionButtons, ...dimensionDropDowns];
    }

    private initTeamAssetsDropdowns(): void {
        o_global.eventQBus.emit('assets.dropdown.init', this.rootSelector);
    }

    /**
 *
 */
    private getDimensionsStateFromDataAttributes(): DimensionValueByType[] {
        const selectedDimensionsEncoded = this.getRootElement().dataset.selectedStateEncoded;
        if (!selectedDimensionsEncoded) {
            throw new Error('cant parse encoded selected dimensions');
        }
        return JSON.parse(decodeHtml(selectedDimensionsEncoded));
    }

    private dimensionChangedEventListener(
        dimType: string,
        control: HTMLInputElement | HTMLSelectElement,
        dimensionTypeUsed?: DimensionType
    ): void {
        const selectedDimensionsState = this.getSelectedDimensionState(dimType, control);

        const productId = this.getRootElement().getAttribute('data-product-id');
        if (productId) {
            selectedDimensionsState.forEach(selectedDimension =>
                updateDimensionSelectionPriorityInStorage(productId, selectedDimension.type)
            );
        }

        const dimensionsStateEvent: DimensionsStateEvent = {
            dimensionStates: getCurrentDimensionsForDimensionStateEvent(this.loadedDimensionsState, selectedDimensionsState, productId),
            selectedState: selectedDimensionsState,
            dimensionTypeUsed,
            dimensionEnabled: isEnabledDimensionInput(control),
        };

        o_global.eventQBus.emit(DIMENSION_SELECTED_TOPIC, dimensionsStateEvent);
    }

    /**
 *
 *
 *
 *
 */
    private getSelectedDimensionState(dimType: string, control: HTMLInputElement | HTMLSelectElement): DimensionValueByType[] {
        return [{ type: dimType, value: control.value }];
    }

    /**
 *
 */
    private getDimensionBlocks(): Array<HTMLElement> {
        return this.getChildElements('[data-dim-type]');
    }
}
